/** Valores por defecto cuando no vienen en la URL (ajustar solo aquí por marca). */
export const UTM_DEFAULT_SOURCE = "directo";
export const UTM_DEFAULT_MEDIUM = "landing_mkt";
export const UTM_DEFAULT_CAMPAIGN = "peugeot";

export function readSessionString(key) {
  if (typeof sessionStorage === "undefined") return null;
  try {
    const v = sessionStorage.getItem(key);
    if (v == null) return null;
    const t = v.trim();
    return t === "" ? null : t;
  } catch {
    return null;
  }
}

function pickFromSearch(search, param) {
  const raw = new URLSearchParams(search).get(param);
  if (raw == null) return null;
  const t = String(raw).trim();
  return t === "" ? null : t;
}

/**
 * `true` si en la query actual faltan `utm_source`, `utm_medium` y `utm_campaign`.
 * @param {string} [query] - Por defecto `window.location.search`.
 */
export function urlSinUtmsPrincipales(query) {
  if (query === undefined || query === null) {
    if (typeof window === "undefined") return true;
    return urlSinUtmsPrincipales(window.location.search || "");
  }
  const s = String(query);
  const q = new URLSearchParams(s.startsWith("?") ? s : s.length ? `?${s}` : "");
  const has = (k) => {
    const v = q.get(k);
    return v != null && String(v).trim() !== "";
  };
  return !has("utm_source") && !has("utm_medium") && !has("utm_campaign");
}

/**
 * Resuelve utm_source y utm_medium desde la query y sessionStorage.
 * @param {string} [search] - Por defecto `window.location.search` en el navegador.
 */
export function resolveUtmSourceAndMedium(search) {
  const s =
    search !== undefined && search !== null
      ? String(search)
      : typeof window !== "undefined"
      ? window.location.search || ""
      : "";

  const fromUrlSource = pickFromSearch(s, "utm_source");
  const fromUrlMedium = pickFromSearch(s, "utm_medium");
  const storedSource = readSessionString("utm_source");
  const storedMedium = readSessionString("utm_medium");

  if (urlSinUtmsPrincipales(s)) {
    return {
      utm_source: storedSource ?? UTM_DEFAULT_SOURCE,
      utm_medium: storedMedium ?? UTM_DEFAULT_MEDIUM,
    };
  }

  return {
    utm_source: fromUrlSource ?? storedSource ?? UTM_DEFAULT_SOURCE,
    utm_medium: fromUrlMedium ?? storedMedium ?? UTM_DEFAULT_MEDIUM,
  };
}
